var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuyerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#seller-icon)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 6C7.105 6 8 5.105 8 4C8 2.895 7.105 2 6 2C4.895 2 4 2.895 4 4C4 5.105 4.895 6 6 6ZM6 7C4.665 7 2 7.67 2 9V9.5C2 9.775 2.225 10 2.5 10L9.5 10C9.775 10 10 9.775 10 9.5V9C10 7.67 7.335 7 6 7Z",
    fill: "#F8B944"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "seller-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyerIcon);
export default __webpack_public_path__ + "static/media/buyer-icon.a897ef5ae6b7161bbfbc5b723e09233e.svg";
export { ForwardRef as ReactComponent };